var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"tabs__buttons"},_vm._l((_vm.children),function(tab,key){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(tab.enabled),expression:"tab.enabled"}],key:key,staticClass:"tabs__tab",class:{'is-active': tab.active, 'tab-disabled': !tab.enabled}},[_c('a',{on:{"click":function($event){_vm.selectTab(tab, $event)}}},[_vm._v(_vm._s(tab.name))])])})),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-130a2b0a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/Tabs.vue
// module id = 827
// module chunks = 1